/*
 * Created on Mon Jul 26 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useState, useEffect, useRef } from 'react';
import { useWindowDimensions, usePrevState } from '../utils/helpers';
import { images, mobileImages } from '../constants';

import { ScrollText } from './manifesto';
import { Carousel } from 'react-bootstrap';
import parse from 'html-react-parser';
import useAuth from 'hooks/auth.hook';

let texts = [
    {
        titleTop: 'the itch',
        titleBottom: 'ecosystem',
        title2: 'about',
        text: `<b>www.itch.me</b> is both an editorial and social <br />
        platform for fashion, your decentralised <br />
        fashion media driven by you. Our <b>zine</b> page <br />
        is where we publish our editorials, such as <br />
        trending artworks, insights as well as your <br />
        <b>articles</b>. You can also showcase your <br />
        <b>gallery</b> of artworks on our <b>home</b> page—our <br />
        social section that invites you to fashion <br />
        your own rules.`,
        text2: `<b>www.itch.me</b> is both<br />
        an editorial and social <br />
        platform for fashion,<br />
        your decentralised <br />
        fashion media driven<br />
        by you. Our <b>zine</b> page <br />
        is where we publish <br />
        our editorials, such as <br />
        trending artworks, <br />
        insights as well as <br />
        your <b>articles</b>. You can <br />
        also showcase your <br />
        <b>gallery</b> of artworks on <br />
        our <b>home</b> page—our <br />
        social section that <br />
        invites you to fashion <br />
        your own rules.`
    },
    {
        titleTop: 'a new<br />fashion bridge',
        titleBottom: '',
        title2: 'to fashion',
        text: `For fashion artists (<b>fa</b>) such as fashion <br />
        <b>designer, model, photographer, <br />
        videographer, hair stylist, makeup artist, <br />
        stylist, nail artist, creative director and <br />
        retoucher,</b> as well as fashion companies <br />
        (<b>fc</b>) that are a <b>brand, service</b> or <b>agency</b> <br />
        or the fashion lover (<b>fl</b>), you can now <br />
        explore a world of alternate inspirations <br />
        and potential partnerships.`,
        text2: `For fashion artists (<b>fa</b>) <br />
        such as fashion <b>designer, <br />
        model, photographer, <br />
        videographer, hair <br />
        stylist, makeup artist, <br />
        stylist, nail artist, <br />
        creative director</b> and <br />
        <b>retoucher</b>, as well as <br />
        fashion companies (<b>fc</b>) <br />
        that are a <b>brand, service</b> <br />
        or <b>agency</b> or the fashion <br />
        lover (<b>fl</b>), you can now <br />
        explore a world of <br />
        alternate inspirations and <br />
        potential partnerships.`
    },
    {
        titleTop: 'how<br /> we <br /> feature<br />you',
        titleBottom: '',
        title2: 'with <br />you',
        text: `
        Artworks trending with the <br/>
        most <b>votes</b> in our <b>home</b> <br/> 
        page will be featured next <br/>
        on our <b>zine</b>. Yes! Instead of <br/>
        creativity subject to opinions <br/>
        by a select few, everyone’s <br/>
        <b>vote</b> will collectively determine <br/>
        our next feature. Better yet, <br/>
        active voters will also be selected <br/>
        and featured in our <b>articles</b> and <br/>
        social media for keeping fashion <br/>
        decentralised on <b>itch</b>. Finally, you <br/>
        have a say to what should trend <br/>
        and the opportunity to be heard.
        `,
        text2: `
        Artworks trending 
        with the most <b>votes</b> 
        in our <b>home</b> page 
        will be featured next on our <b>zine</b>. 
        Yes! Instead of creativity subject to 
        opinions by a select few, everyone’s 
        <b>vote</b> will collectively determine 
        our next feature. Better yet, 
        active voters will also be selected 
        and featured in our <b>articles</b> and 
        social media for keeping fashion 
        decentralised on <b>itch</b>. Finally, you 
        have a say to what should trend 
        and the opportunity to be heard.
        `
    },
    {
        titleTop: 'fashion',
        titleBottom: 'by you',
        title2: 'a change',
        text: `
        What’s more, the timeline of our <b>home</b> page is also chronologically <br/>
        determined by you. Whether you’re revealing a new artwork or <br/>
        interacting with other artworks such as: <b>vote, view, itchbook</b> or <b>comment</b>, <br/>
        the order of our feed is transparently based on your last action. <br/>
        The more you interact on our <b>home</b> page, <br/>
        the more you’ll increase your profile visibility.
        `,
        text2: `
        What’s more, the timeline of our <b>home</b> page is also chronologically
        determined by you. Whether you’re revealing a new artwork or
        interacting with other artworks such as: <b>vote, view, itchbook</b> or <b>comment</b>,
        the order of our feed is transparently based on your last action.
        The more you interact on our <b>home</b> page,
        the more you’ll increase your profile visibility.
        `
    },
    {
        titleTop: "join us, it's free",
        titleBottom: '',
        title2: 'with <br />you',
        text: `In an industry that takes more<br/> 
        than giving back, our journey is<br/>
        to fashion a makeover—starting<br/>
        by giving creative control back<br/>
        to the hands of fashion<br/>
        creatives and enthusiasts. <br/>
        No hooks, no catch, <br/>
        no fashion rulebook—just do you. <br/>
        So <a href="/signup">sign up</a> to create your <span class="pn-bold">itch</span> account<br/> 
        and let’s revive the spirit of<br/>
        fashion all together!`,
        text2: `In an industry that takes more
        than giving back, our journey is
        to fashion a makeover—starting
        by giving creative control back
        to the hands of fashion
        creatives and enthusiasts. 
        No hooks, no catch, 
        no fashion rulebook—just do you.
        So <a href="/signup">sign up</a> to create your <span class="pn-bold">itch</span> account
        and let’s revive the spirit of fashion all together!`
    }
]

export default function HowItWorks() {
    const { session } = useAuth()
    const [index, setIndex] = useState(0);
    const [touchX, setTouchX] = useState(0);
    const [touchY, setTouchY] = useState(0);
    const [opacity, setOpacity] = useState(1);
    const [slideToPrev, setSlideToPrev] = useState(false);
    const [lightDimensions, setLightDimensions] = useState({
        lightWidth: 0,
        lightHeight: 0,
        lightTop: 0,
        lightLeft: 0
    });
    const { lightWidth, lightHeight, lightTop, lightLeft } = lightDimensions;
    const carouselRef = useRef();
    const lightImgRef = useRef();

    // let imgWidth = 890;
    let imgHeight = 1550;

    const { windowWidth, windowHeight } = useWindowDimensions();
    const prevIndex = usePrevState(index);
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
        selectedIndex > index ? setSlideToPrev(false) : setSlideToPrev(true);
    }
    const handleWheel = (swipe) => {
        setTimeout(() => {
            // swipe left
            if (swipe > 0) {
                setSlideToPrev(false);
                if (index !== 4) carouselRef.current.next()
            }
            else {
                setSlideToPrev(true);
                if (index !== 0) carouselRef.current.prev()
            }
        }, 250);
    };
    const handleTouch = e => {
        let lastTouch = e.changedTouches[0];
        let xDiff = touchX - lastTouch.clientX;
        let yDiff = touchY - lastTouch.clientY;
        // get most significant motion
        handleWheel(Math.abs(xDiff) > Math.abs(yDiff) ? xDiff : yDiff);
    };

    const slideInLeft = (i) => i <= prevIndex && i === index && slideToPrev ? 'prev-item' : '';

    const positionLights = () => {
        if (lightImgRef.current) {
            const { width, height, left } = lightImgRef.current.getBoundingClientRect();
            let lightSize = 485 / imgHeight * width + 10;
            setLightDimensions({
                lightWidth: lightSize,
                lightHeight: lightSize,
                lightTop: height - lightSize * 2.5,
                lightLeft: left + lightSize * 1.5 - 30
            })
        }
    }

    useEffect(() => {
        setTimeout(() => {
            index === 0 ? setOpacity(1) : setOpacity(0)
        }, 1000);
    }, [index])

    useEffect(() => {
        if (index === 2 && !slideInLeft(2)) {
            setTimeout(() => {
                positionLights()
            }, 1100);
        }
        // eslint-disable-next-line
    }, [index])
    useEffect(() => {
        positionLights()
        // eslint-disable-next-line
    }, [windowWidth, windowHeight])

    return (
        <>
            <ScrollText goNext={() => carouselRef.current.next()} opacity={opacity} addClass="hiw" />
            <Carousel
                ref={carouselRef}
                id="tourSlide"
                className={"hiw " + (session ? "logged-in" : "")}
                activeIndex={index}
                onSelect={handleSelect}
                onWheel={(e) => handleWheel(e.deltaY > 0)}
                onTouchStart={(e) => {
                    setTouchX(e.touches[0].clientX); 
                    setTouchY(e.touches[0].clientY)
                }}
                onTouchMove={handleTouch}
                interval={null}
                touch={false}
                nextIcon=""
                prevIcon=""
            >
                <Carousel.Item id="hiwItem0" className={slideInLeft(0)}>
                    <TextDiv index={0} bottom={true} displayStyle="block" />
                    <ImgDiv index="1a" addClass="black-button" />
                    <ImgDiv index="1b" addClass="white-button" />
                </Carousel.Item>
                <Carousel.Item id="hiwItem1" className={slideInLeft(1)}>
                    <TextDiv index={1} displayStyle="block" />
                    <ImgDiv index={2} />
                </Carousel.Item>
                <Carousel.Item id="hiwItem2" className={slideInLeft(2)}>
                    <TextDiv index={2} displayStyle={windowWidth > 1030 ? "table-cell" : "block"} />
                    {windowWidth > 1030 ? 
                        <div id="lights" style={{
                            width: lightWidth,
                            height: lightHeight,
                            top: lightTop,
                            left: lightLeft
                        }}></div>
                    : null}
                    <div className="hiw-img-div">
                        <img
                            ref={lightImgRef}
                            className="middle-x"
                            src={windowWidth > 1030 ? images['hiw-slide-3.png'] : mobileImages['hiw-slide-3.png']}
                            alt="background"
                        />
                    </div>
                </Carousel.Item>
                <Carousel.Item id="hiwItem3" className={slideInLeft(3)}>
                    <TextDiv index={3} bottom={true} displayStyle="block" />
                    <ImgDiv index={4} />
                </Carousel.Item>
                <Carousel.Item id="hiwItem4">
                    <TextDiv index={4} displayStyle="block" />
                    <ImgDiv index="5a" addClass="brush" />
                    {windowWidth > 1030 ? <ImgDiv index="5b" addClass="pod" /> : null}
                </Carousel.Item>
            </Carousel>
        </>
    )
}

function TextDiv({ index, bottom, displayStyle }) {
    const { windowWidth } = useWindowDimensions();
    return (
        <div className="hiw-text-div pink-text middle-xy">
            <p className={"nexa-x-bold title d-" + displayStyle}>{parse(texts[index].titleTop)}</p>
            {bottom ?
                <p className={"nexa-x-bold title d-" + displayStyle}>{parse(texts[index].titleBottom)}</p>
                : null}
            <p className={`text text-left d-${displayStyle}`}>{parse(windowWidth > 1030 ? texts[index].text : texts[index].text2)}</p>
        </div>
    )
}

function ImgDiv({ index, addClass }) {
    const { windowWidth } = useWindowDimensions();
    let img = 'hiw-slide-' + index + '.png';
    return (
        <div className={"hiw-img-div " + (addClass ? addClass : '')}>
            <img
                className="middle-x"
                src={windowWidth > 1030 ? images[img] : mobileImages[img]}
                alt={`slide ${index[0] || index} background`}
            />
        </div>
    )
}